import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import CampaignTemplates from "./templates";

export default function CampaignTemplateRoutes(props) {
  const { match } = props;
  return (
    <>
      <Switch>
        <Route exact path={`${match.url}`} component={CampaignTemplates} />
        <Route exact path={`${match.url}/:channel`} component={CampaignTemplates} />
        <Redirect to={`${match.url}`} />
      </Switch>
    </>
  );
}
